import { useMutation, useQueryClient } from "@tanstack/react-query";

//** Request/Response mappings */
import { createQuoteRequestMapping } from "../../mapping/createQuoteRequestMapping.js";
import { createQuoteResponseMapping } from "../../mapping/createQuoteResponseMapping.js";

import useSharedData from "../useSharedData.ts";

//** Axios request */
import { request } from "../../utilities/axios-utils.js";

import { queryKeys } from "./queryKeys.js";

//** Mock Test Data */
// import { createQuoteResponse } from "../../data/mock/create-quote-response-mock-data.js";
import usePreQualificationPages from "../usePreQualificationPages.ts";
import { pageOrder } from "../../config/pageInfo/pageOrder.js";

//----------------------------------------------------------------

const postCreateQuote = async (data, isDevShared = false) => {
  const { updateData, oktaToken } = { ...data };

  const quoteData = oktaToken == null ? data : updateData;
  //* TODO:isDev PRE-DEPLOY
  const isDev = isDevShared;
  if (isDev === true && import.meta.env.MODE === "development") {
    import("../../data/mock/create-quote-response-mock-data.js")
      .then((module) => {
        const createQuoteResponse = module?.createQuoteResponse;
        return createQuoteResponseMapping(createQuoteResponse());
      })
      .catch((error) => {
        console.log("Error loading mock data: ", error);
      });
  }

  if (quoteData == null) {
    return;
  }

  //* Check where the call is being made from Online or CC?
  const application = quoteData.application;
  const requestURL =
    application === "online" ? "/createQuote" : "/callCentreCreateQuote";
  try {
    let mappedRequest = await createQuoteRequestMapping(quoteData);

    const response = await request({
      url: requestURL,
      method: "POST",
      data: JSON.stringify(mappedRequest),
      ...(oktaToken != null && {
        oktaAccessToken: oktaToken,
      }),
    });

    if (200 === response.status) {
      return createQuoteResponseMapping(response);
    } else {
      throw response;
    }
  } catch (error) {
    throw error;
  }
};

export const useCreateQuoteMutation = () => {
  const queryClient = useQueryClient();
  const { openErrorModal, isDevShared } = useSharedData();
  const { state, funcs } = usePreQualificationPages();

  return useMutation({
    mutationFn: (data) => {
      return postCreateQuote(data, isDevShared);
    },
    onSuccess: (data) => {
      //* Save the response to the TanStack cache.
      if (data != null) {
        queryClient.setQueryData([queryKeys.QUOTE_DATA_GET], data || {});
        queryClient.invalidateQueries(["premiumProjectionData"]);
      }
    },
    onError: (err) => {
      // Do something when an error is thrown
      console.log("Error", err);
      if (err.response.status === 406) {
        // this is decline scenario --> take user to the decline page
        funcs.validateAndProceed(pageOrder.APPLICATION_ALREADY_DECLINED, true);
      } else {
        openErrorModal();
      }
    },
  });
};
